import axiosInstance from './axiosInstance'

export const getAllCourses = async () => {
  const response = await axiosInstance.get('/api/academic/courses')
  return response.data
}

export const getAllAasPrograms = async () => {
  const response = await axiosInstance.get('/api/academic/aas-programs')
  return response.data
}

export const getAllConcentrations = async (institution = '') => {
  const url = institution ? `/api/academic/concentrations?institution=${institution}` : '/api/academic/concentrations'
  const response = await axiosInstance.get(url)
  return response.data
}

export const getAvailableTargets = async (aasId, institution = '') => {
  const url = `/api/academic/aas-programs/${aasId}/available-targets?institution=${institution}`
  const response = await axiosInstance.get(url)
  return response.data
}

export const getAllInstitutions = async () => {
  const response = await axiosInstance.get('/api/academic/institutions')
  return response.data
}

export const getTransferMappings = async (aasId, basId) => {
  const response = await axiosInstance.get(`/api/academic/mappings?aasId=${aasId}&basId=${basId}`)
  return response.data
}

export const getPathwayRelationships = async () => {
  const response = await axiosInstance.get('/api/academic/pathway-relations')
  return response.data
}

export const downloadSyllabusSource = async (courseCode) => {
  const response = await axiosInstance.get(`/api/academic/syllabi/download/${courseCode}`, {
    responseType: 'blob'
  })
  return response.data
}

export const downloadMasterExcel = async () => {
  const response = await axiosInstance.get('/api/academic/admin/master-excel/download', {
    responseType: 'blob'
  })
  return response.data
}
